import React from 'react';
type SectionLabelProps = {
  children: React.ReactNode;
  className?: string;
};

/** Shared eyebrow used to orient readers without competing with the content. */
export function SectionLabel({
  children,
  className = ''
}: SectionLabelProps) {
  return <p className={`flex items-center gap-3 font-display text-sm font-medium uppercase tracking-[0.12em] text-muted ${className}`} data-id="element-385" data-mp="2ycq13o719p1y">
      <span aria-hidden="true" className="h-px w-8 bg-foreground" data-id="element-386" data-mp="3r2yobugfezne" />
      {children}
    </p>;
}